import LocalizedStrings from 'react-localization'

export let languages = [
  { code: "en", name: "English" },
  { code: "es", name: "Español" },
  { code: "pt", name: "Português" }
]

export let localizer = new LocalizedStrings({
  en: {

    //
    // General:
    //
    Add: "Add",
    Accept: "Accept",
    AcceptAll: "Accept all",
    End: "Finish",
    Cancel: "Cancel",
    NoCancel: "No Cancel",
    Cancelled: "Cancelled",
    CommsError: "An error has occurred, try again please",
    Country: "Country",
    Days: "days",
    Delete: "Delete",
    NoDelete: "No Delete",
    Description: "Description",
    Edit: "Edit",
    Import: "Import",
    LoadMore: "Load more",
    LockUser: "Lock",
    Name: "Name",
    Next: "Next",
    Of: "de",
    Page: "Page",
    Previous: "Previous",
    Save: "Save",
    Saved: "Saved",
    Schedule: "Schedule",
    Scheduled: "Scheduled",
    Send: "Send",
    Shipment: "Shipment",
    Status: "Status",
    Type: "Type",
    Reference: "Reference",
    User: "User",
    Used: "Used",
    Uploaded: "Uploaded",
    View: "View",
    Recipient: "recipient",
    Sender: "sender",
    Unlock: "Unlock",  
    Lock: "lock",      
    Identify: "Identify",
    Language: "Language",
    Logout: "Logout",
    No: "Not",
    Yes: "Yes",
    Shipments: "Shipments",    
    Download: "Download",
    Since: "Since",
    Until: "Until",
    GroupUsers: "Group users",
    ReDispatches: "Redispatches",
    Size: "Size",
    Date: "Date",
    Office: "Office",
    Selected: "Selected",
    Back: "Back",
    SelectAll: "Select all",
    UnSelectAll: "Unselect all",
    ExportExcel: "Export Excel",
    Month: "Month",
    Year: "Year",
    Generate: "Generate",
    Warning: "Warning",
    NumberOfShipments: "Number of shipments",
    Enable: "Enable",
    Disable: "Disable",
    Billable: "Billable",
    Actions: "Actions",
    ClickHere: "Click here.",
    WelcomePostamail: "Welcome to PostaMail",
    WelcomeSelectRealm: "Hi {0}! Select the realm you want to work in",

    Client: "Client",
    ShipmentCode: "Shipment code",
    PrintType: "Print type",
    TotalPages: "Total pages:",
    FirstPage: "First page",
    NextPages: "Next pages",
    TotalCost: "Total cost:",
    Cost: "Cost",
    Pages: "Pages",

    Colour: "Colour",
    Gray: "Gray",
    Duplex: "Duplex",
    Simplex: "Simplex",

    January: "January",
    February: "February",
    March: "March",
    April: "April",
    May: "May",
    June: "June",
    July: "July",
    August: "August",
    September: "September",
    October: "October",
    November: "November",
    December: "December",
    //
    // Top layout:
    //
    TermsAndConditions: "Terms and Conditions",
    DataProtectionPolicy: "Data Protection Policy",
    CookiesPolicy: "Cookies Policy",
    AppBarShipmentsManagement: "Shipments management",
    AppBarShipments: "Shipments",
    AppBarShipmentsSaved: "Saved",
    AppBarOutbox: "Outbox",
    AppBarInbox: "Inbox",
    AppBarDrafts: "Drafts",
    AppBarDocuments: "Documents",
    AppBarTracking: "Tracking",
    AppBarCredit: "Credit",
    AppBarHelp: "Help",
    AppBarInvitations: "Invitations",
    AppBarBilling: "Billing",

    //
    // API docs:
    //
    DocsSidebarTitle: "PostaMail API",
    DocsSidebarSubtitle: "Integration guide",
    DocsDownloadOpenApi: "Download OpenAPI",
    DocsSearchPlaceholder: "Search docs...",
    DocsPageNotFound: "This page does not exist. Pick a topic from the sidebar.",
    DocsGroupGettingStarted: "Getting Started",
    DocsGroupApiReference: "API Reference",
    DocsGroupObjectTypes: "Object Types",
    DocsGroupAnnexes: "Annexes",
    DocsTitleIntroduction: "Introduction",
    DocsTitleAuthentication: "Authentication",
    DocsTitleErrors: "Errors",
    DocsTitleShipments: "Shipments (Outbox)",
    DocsTitleReturns: "Returns (Inbox)",
    DocsTitleWebhooks: "Webhook (Watcher)",
    DocsTitleSession: "Session",
    DocsTitleShipmentObjects: "Shipment objects",
    DocsTitleReturnObjects: "Return objects",
    DocsTitleProductTypes: "Product types",
    DocsTitleShippingConsiderations: "Shipping considerations",

    //
    // Login component:
    //
    PleaseLogIn: "Log In with your PostaMail account",
    YouAreLoggedIn: "You are logged in as",
    LogIn: "LOG IN",
    LogOut: "LOG OUT",
    Email: "E-mail",
    Password: "Password",
    ForgotPassword: "Did you forget your password?",
    IncorrectCredentials: "Incorrect e-mail or password",
    YourAreLoggedInAs: "You are currently logged in as:",
    CloseSession: "Close Session",
    LoginSelectRealm: "Select",
    LoginInRealmAs: "You will log in this realm as ",
    ForgotPasswordInfo: "Insert your email and instructions to reset your password will be sent to the indicated address.",
    HelpPassword: "Password help",
    HelpPasswordSend: "An email will be sent with instructions if the email address is valid",
    NotFound: "No data",
    WaitingData: "Waiting for data...",
    MfaTitle: "Verification code",
    MfaInfo:"We have sent a verification code to your email. To complete the login process, enter the 6-digit code provided in that email and press Send.",

    //
    // Sign up component and replace password: 
    //
    WelcomeSignup: "Define password",
    WelcomeSignupDescription: "Welcome to PostaMail, in order to complete your sign up you just need to define your password",
    YourLoginWillBe: "Your login identifier will be",
    SignupCurrentPassword: "Current Password",
    SignupPassword: "Password",
    SignupPasswordRepeat: "Repeat your new password",
    PasswordsMismatch: "Passwords mismatch",
    Signup: "SIGN UP",
    OnSignupAcceptTerms: "By creating an account, you agree to PostaMail's {0} and {1}",
    UseConditions: "Conditions of Use",
    PrivacyPolicy: "Privacy Notice",
    PasswordMustMeet: "Password must meet the following rules:",
    RequiredMinLength: "Required at least {0} characters",
    RequiredOneDigit: "Required at least 1 numerical digit",
    RequiredOneLower: "Required at least 1 lowercase letter",
    RequiredOneUpper: "Required at least 1 uppercase letter",
    RequiredOneNonAlpha: "Required at least 1 non-alphanumeric symbol",
    RequiredMinDiffChars: "Required at least {0} different characters",
    StrengthOfPassword: "The strength of your password is:",
    PassStrengthVeryWeak: "very weak",
    PassStrengthWeak: "weak",
    PassStrengthAcceptable: "acceptable",
    PassStrengthGood: "good",
    PassStrengthStrong: "strong",
    PassStrengthShort: "too short",
    UserEmail: "Current email",
    WelcomeReplacePassword: "Change your password",
    ReplacePassword: "Replace plassword",
    ReplacePasswordMain :"Replace password",
    ChangeGroup :"Change group",
    ReplacePasswordSuccess: "Your password was changed successfully",
    ExpirationPasswordMessage: "The password will be expired in ",
    ExpirationPasswordDays: " day(s).",
    SessionExpiredTitle: "Session closed",
    SessionExpiredMessage: "Your session has been closed due to inactivity. Please log in again to continue.",
    SessionExpiredAccept: "Go to login",
    RecoverPassword: "Recover password",
    ReplacePasswordDescription: "This section you can replace your password by complying with the required rules",

    //
    // Documents component:
    //
    Documents: "Documents",
    Document: "Document",      
    NewDocument: "New document",
    DocumentName: "Document name",
    DocumentDescription: "Document description",
    DocumentPreview: "Document preview",
    DeleteDocument: "Delete document",
    DeleteDocumentConfirmation: "Are you sure you want to delete the document?",

    Drafts: "Drafts",      
    NewDraft: "New Draft",      
    Draft: "Draft",  
    DraftName: "Document's file name",
    DraftDescription: "Document description",
    DraftPreview: "Document preview",
    DeleteDraft: "Delete draft",
    DeleteDraftConfirmation: "Are you sure you want to delete the draft ",
    InfoDontRemove: "It cannot be deleted because it is associated with some shipment/s",

    //
    // Shipments component:
    //
    Outbox: "Outbox",
    NewShipment: "New shipment",    
    Sent: "Sent",
    Addressee: "Addressee",
    Tracking: "Tracking",
    DeleteShipment: "Delete shipment",
    CancelShipment: "Cancel shipment",
    DeleteOrCancelShipment: "Delete or Cancel shipment",
    DeleteShipmentConfirmation: "Will be removed (it will disappear from the mailing list).",
    PossibleActions: "You can perform the following actions:",
    CancelAndDeleteShipmentConfirmation: " has not yet been processed by Postamail. You can perform the following actions:",
    CancelShipmentConfirmation: " it has already been processed by Postamail. Proceed with the attempt to cancel the shipment?",
    DoNothing: "Do nothing",
    DeleteShipmentInformation: "Delete shipment (it will disappear from the mailing list)",    
    DeleteShipmentAndDraft: "Delete shipment (it will disappear from the mailing list) as well as the associated document file",
    OnlyCancel: "Cancel shipment (it will appear as a canceled shipment)",
    AreYouSure: " Are you sure?.",
    TheShipment: "The shipment ",
    ExpandMore: "View more",
    ExpandLess: "View less",
    GoToTracking: "Go to postal operator tracking",
    ViewDocument: "View document",
    EditViewShipment: "View the shipment summary or edit if it has not yet been processed by Postamail",
    EditShipment: "Edit shipment",
    CancelDeleteShipment: "Cancel or delete the shipment if it has not yet been processed by Postamail",
    CannotBeDeletedShipment: "Shipment has already been processed  or belongs to another user. It can not be deleted",
    CannotBeEditedShipment: "A shipment can only be edited if it has not yet been processed by PostaMail and if you are the one who sent it.",
    ShipmentsDetectRefence: "Automatic reference detections",
    CleanRefences: "Clean references",
    OCAaddressDetection: "Automatic address detection",
    SimplexPrinting: "Single-sided",
    DuplexPrinting: "Double-sided",
    BlackAndWhite: "Black and white",
    SimplexPrintingDescription: "Printed on only one side of the paper",
    DuplexPrintingDescriptionProp1: "Printed on both sides of the paper",
    DuplexPrintingDescriptionProp2: "Reduces the enviroment impact",
    BlackAndWhiteDescription: "Printed in black",
    ColourDescription: "Printed in full colour",
    PrintEco: "Eco",
    PrintColourTitle: "Print colour options",
    PrintSimplexDuplexTitle: "Print simplex/duplex options",
    ShowCancelRequested: "Only show shipments with cancellation request",
    ThirdPartyEmailDescription: "Please enter an email address to send these notifications.",
    ThirdPartyEmail: "Third party email",
    ThirdPartyEmailSend: "Notify to third party",
    InvalidEmail: "Invalid email address",
    EmailsDoesNotMatch: "The emails do not match",
    RepeatEmail: "Repeat email",
    NotifyToThirdParty: "Third party to notify",
    ThirdPartyEmailExplain: "You can notify a third party about updates related to this shipment. The email address you enter will receive:",
    ThirdPartyEmailExplain1: "Notification about the confirmation of the shipment",
    ThirdPartyEmailExplain2: "Electronic Proof of Delivery of the shipment when available",
    ThirdPartyEmailExplain3: "Certificate of the shipment when available",
    ThirdPartyEmailNotifyTo: " will receive the updates about this shipment",
    ThirdPartyEmailExplainTitle: "Notify a Third Party About the Shipment",
    ShipmentNT2Restriction: "Case number is mandatory for administrative noticements",
    ShipmentNT2ReferenceRequired: "For NT2 shipments, it is mandatory to include as reference the file number",
    ShipmentReferenceMaxLength: "The shipment reference cannot exceed 100 characters",

    //
    // Outbox:
    //
    SenderAddress: "Sender Address",
    RecipientAddress: "Recipient Address",
    AddresseeNameSender: "Sender's full name",
    AddresseeNameRecipient: "Recipient's full name",
    AddresseDocumentId: "Identification Document",
    Phone: "Phone",
    ContactPerson: "Contact person",
    Locality: "Locality",
    PostalCode: "P. C.",
    TypeOfRoad: "Type of road",
    StreetName: "Street name",
    StreetNumber: "Street nº",
    FullAddress: "Full address",
    AddressComplement: "Address complement",
    SelectAddress: "Select address",
    DetectAddress: "Single shipment address",
    PrintView: "Print view",
    SelectedPagesInfo: "Separate full ranges with a hyphen, or single pages with commas",
    EditDraft: "Edit document",
    DraftNoDocumment: "There is no document uploaded",
    FillAddressesInfo: "Fill in the sender and recipient addresses",
    FillFormInfo: "Indicate the sender’s address (if not the default one) and the recipient’s address.",
    ShipmentNewId: "Unique identifier/s created by the system",
    NewShipmentQuestionText: "Would you like to make a new shipment?",
    NewShipmentInstructionsHeaderText: "Indicate the shipping reference and choose the options",
    NewShipmentInstructionsText: "Fill in the reference with which you want to save these shipments, in addition to the printing options.",
    NewShipmentText: "New shipment",
    ScheduleShipmentHeaderText: "Schedule shipment",
    DraftSelectionText: "Select one or more documents",
    DraftSelectionHeaderText: "Select the document(s) you want to send.",
    DraftEditingText: "File name and description",
    DraftPagesSelectionHeaderText: "Select the draft pages you want to submit",
    DraftPagesSelectionText: "Select in each draft the pages to send. If you wish to submit the entire draft, leave the field blank. Separate page ranges with a hyphen and single pages with commas.  For example, 1, 3, 5-12",
    ProductTypeSelectionHeaderText: "Select the type of product you want to send.",
    ProductTypeSelectionHeaderTitle: "Select product type",
    DetectReference: "Detect reference",
    FooterAdviceText: "All paper used in making your shipment is FSC® or PEFC certified, which are standards that guarantee that the paper comes from certified forests managed in a sustainable and controlled manner.",
    ShippingEstimatedCostText: "Shipping Cost with VAT",
    ShippingEstimatedCostTextNoVAT: "Shipping Cost without VAT",
    ShippingEstimatedCostVat: "VAT",
    ShipmentSumary: "Shipment summary",
    ShipmentSummaryHeaderText: "This is the summary of your shipments. Review the details and, if necessary, return to the previous screen to make corrections. If everything is fine, you can 'Save' for later, 'Schedule' the departure date and time, or 'Send' directly",
    ShipmentSummaryType: "Shipment type",
    ShipmentSummaryBatch: "Batch",
    ShipmentSummaryIncludedPages: "Included pages",
    ShipmentSummarySender: "Sender",
    ShipmentSummaryAddressee: "Addressee",
    ShipmentSummaryPrintOptions: "Print options",
    ShipmentSummaryCost: "Cost",
    ShipmentSumaryRefence: "Reference",
    ShipmentReference: "Shipment's reference",
    ShipmentProgressStep1: "Select product",
    ShipmentProgressStep2: "Select document (s)",
    ShipmentProgressStep3: "Destination Address",
    ShipmentProgressStep4: "Shipment Options",
    ShipmentProgressStep5: "Send",
    ValidationFieldAddressee: "You must fill in the recipient",
    ValidationFieldTextIdCard: "ID number incorrect format",
    ValidationFieldTextLocality: "You must fill in the locality",
    ValidationFieldTextPostalCode: "You must fill in the postal code",
    ValidationFieldTextDestinatioAddress: "You must fill in the recipient",
    AddressSelectorSenderText: "Sender Address",
    AddressSelectorRecipientText: "Recipient address",
    ConfirmationScheduledText: "Shipment will be sent on ",
    ConfirmationStoredText: "To send it, you will have to access it again and use the options Send or Schedule",
    ConfirmShipmentNumber: "{0} shipment/s have been issued successfully.",
    ConfirmShipmentText: "The identifiers generated for your shipments will be shown below.",
    ConfirmShipmentWithBatchText: "El lote {1} se ha emitido correctamente conteniendo {0} envío/s.",
    Resend: "Resend",
    ResendShipment: "Resend shipment",
    ResendConfirm: "Shipment data will be copied into a new shipment but it will have even a new identificator. Are you sure you want to resend the shipment?",
    CannotBeResent: "Shipment can not be resent cause current user is not the owner of the shipment",
      
    ShipmentPageTooltipInfo: "Type page numbers in ranges separated by commas counting from the beginning of the document or section. For example, 1, 3, 5-12",
    OcrProcessTitle: "Accept or Select the area where the full address of the recipient is located. If you want to know more about the allowed format for using automatic address detection ",
    OcrProcessReferenceTitle: "Accept or Select the area where the reference of the shipment is located",
    OcrSingleShipment: "Single shipment",
    OcrMultiShipment: "Multiples shipments",
    ReferenceError:"The reading of some reference could not be detected",
    Multishipment: "Multiple shipment address",
    SelectInitialPage: "Select as initial page of a shipment",
    ExcludePage: "Exclude page",
    IncludePage: "Include page",
    PDFPreview: "Shipment document preview",
    AddressNotDetected: "No address detected",
    ShipmentsSuccessful: "All shipments have been successfully completed",
    ShipmentsSaved: "All shipments have been saved",
    ShipmentProgrammed: "All shipments have been programmed",
    ShipmentSent: "All shipments have been sent",
    Successful: "successfully",
    NoDraftSelected: "No document selected",
    NoReferenceDetected: "No reference detected",
    PreparedShipments: "Shipments prepared ",
    BatchGroupingHint: "If a high volume of shipments are to be made simultaneously, grouping them into a batch will facilitate their subsequent location and management.",
    BatchGroupingCheckLabel: "Group these shipments in a batch",
    BatchLabelField: "Batch label",
    BatchLabelRequired: "If you enable batch grouping, you must provide a batch label.",
    BatchLabelTooLong: "Batch label cannot exceed 256 characters.",
    DraftTotalPagesLimitExceeded: "The total number of selected draft pages cannot exceed {0}.",
    UnexpectedBatchSaveError: "Unexpected error during batch save.",
    NumShipments: " shipment/s",
    NextAppointment: "Date scheduled",
    Get : "Get",
    AboutUse: "on the use of this screen.",
    Information: "Information",
    AlertSenderEmpty: "You must fill in the sender address first",        
    Filter: "Filter",     
    CleanFilter: "Clean",  
    OptionNotFound: "Option not found",
    AllBatches: "All batches",
    BatchSearchPlaceholder: "Search batch",
    TotalShipments: "Shipments",
    TotalDisplayed: "Showing",
    TotalSelected: "Selected",
    ExpandMoreFilter: "View more filters",
    ExpandLessFilter: "View less filters",
    FindShipments: "Shipment search",
    OutboxDownloadReturns: "Download shipments returns",
    OutboxDownloadExcel: "Export Excel",
    OutboxDownloadLimitExceeded: "No more than {0} shipments can be downloaded at once. {1} are selected.",
    OutboxDateRangeMaxThreeMonths: "Queries longer than three months are not allowed",
    OutboxShipmentCodeSearchIgnoresDateRange: "When searching by shipment code, the date range is not applied",
    OutboxNotBeCanceled: "Your shipment could not be canceled because it has already been processed by Postamail. This will be attempted as far as possible by our staff.",

    AddressErrorEmpty: "Address can not be empty",
    AddressErrorWho: "Who field can not be empty",
    AddressErrorIdentification: "Identification document field can not be empty and it must be valid",
    AddressErrorCountryIso: "Country field can not be empty",
    AddressErrorLocality: "Locality field can not be empty",
    AddressErrorPostalCode: "Postal code field can not be empty",
    AddressErrorStreetName: "Street name field can not be empty",
    AddressErrorStreetNumber: "Street number field can not be empty",
    AddressError: " address errors:",
    AddressErrorSender: "Sender",
    AddressErrorDestination: "Recipient",
    AddressErrorPostalCodeMask: "Postal code does not match the country",
    AddressErrorLengthWhoBur: "Who field must be less than 50 characters",
    AddressErrorLengthWho: "Who field must be less than 100 characters",
    AddressErrorLengthStreetName: "Full address field must be less than 100 characters",
    AddressErrorCountryNational: "For International Ordinary Letters, the recipient can not be in Spain",
    AddressErrorCountryInternational: "For International products, the recipient can not be in Spain or Portugal",
    AddressErrorCountryDomestic: "For Domestic products, the recipient must be in Spain or Portugal",
    ShipmentWithoutProduct: "You must select a product to continue",
    NoMappingFound: "No configuration found for this product. Please get in touch with support.",

    FileNotValid: "The file is not valid",
    FileNotValidExtension: "The file extension is not valid",
    FileNotValidSize: "The file size is not valid. The maximum allowed size is 20 MB.",

    ///
    /// Address formats:
    ///
    AddressFormats: "Address formats",
    AddressFormatsIntroduction: "To maximize OCR reading quality, it's important that the recipient's address is written in the correct format. Below are examples of how it should be written:",
    AddressFormatsLine1: "Line 1: ",
    AddressFormatsLine2: "Line 2: ",
    AddressFormatsLine3: "Line 3: ",
    AddressFormatsLine4: "Line 4: ",
    AddressFormatsLine1Description: "Full name of the recipient",
    AddressFormatsLine2Description: "Street name, number and complement",
    AddressFormatsLine3Description: "Postal code and locality",
    AddressFormatsLine4Description: "Country",
    AddressFormatsLine1Explanation: "The first line will always be the recipient's name.",
    AddressFormatsLine2Explanation: "The intermediate lines will be concatenated to form the address line.",
    AddressFormatsLine3Explanation: "The third line will always contain the postal code and city.",
    AddressFormatsLine4Explanation: "The last line will always contain the country. Otherwise Spain is assumed.",
    ///
    /// Inbox:
    ///
    InboxTitle: "Inbox",
    InboxDescription: "Description",
    InboxInformation: "Return Information",
    InboxType: "Type",
    InboxShipment: "Shipment",
    InboxRecipient: "Shipment Recipient",
    InboxRecordedTime: "Recorded Time",
    InboxUser: "User",
    InboxDocument: "Document",
    InboxStampedCopy: "Stamped copy",
    InboxStateTracking: "State Tracking",
    InboxProof: "Delivery Proof",
    InboxCert: "Certificate",
    InboxReport: "Report",
    InboxView: "View",
    InboxUnread: "items unread",
    InboxCheckAllAsRead: "Mark all as read",
    InboxCheckSelectedAsRead: "Mark selected as read",
    InboxCheckSelectedAsUnread: "Mark selected as unread",
    InboxShipmentType: "Product type",
    InboxIncludedPages: "Included pages",
    InboxSender: "Sender",
    InboxDestination: "Recipient",
    InboxPrintFeatures: "Print features",
    InboxPrice: "Price",
    InboxDuplex: "Double-sided",
    InboxSimplex: "Single-sided",
    InboxChronology: "Chronology",
    InboxDateHour: "Timestamp",
    InboxEvent: "Event",
    InboxShowStates: "Show States",
    InboxShowProofs: "Show Proofs",
    InboxShowCerts: "Show Certs",
    InboxShowDocuments: "Show Documents",
    InboxShowStampedCopy: "Show Stamped Copies",
    InboxShowReports: "Show Reports",
    InboxCetificates: "Certificates",
    InboxProofs: "Proofs",
    InboxStates: "States",
    InboxReports: "Reports",
    InboxDocuments: "Documents",
    InboxDocumentOriginal: "Original document",
    PostalOperator: "Postal Operator Tracking",
    InboxReadAllSuccess: "All returns marked as read",
    InboxUnReadAllSuccess: "All returns marked as unread",
    InboxShipmentInfo: "Shipment info",
    InboxShipmentDetails: "Shipment details",
    InboxShipmentCode: "Shipment code",
    InboxDownload: "Download",
    InboxPreview: "Preview",
    InboxViewAll: "View all",    
    InboxNotSent: "Not Sent",
    InboxSaved: "Saved",
    InboxSent: "Issued",
    InboxProgrammed: "Programmed",
    InboxFindReturn: "Return search",
    InboxStateCAN: 'Cancelled',
    InboxStateCNR: 'Cancellation request',
    InboxStateDEL: 'Delivered',
    InboxStateDIE: 'Died',
    InboxStateDLD: 'Delivered Destination',
    InboxStateDLO: 'Delivered Postal Office',
    InboxStateEPD: 'Electronic Proof of Delivery',
    InboxStateEPR: 'Electronic Proof of Return',
    InboxStateEXP: 'Expired',
    InboxStateLST: 'Lost',
    InboxStateNIF: 'No information',
    InboxStateNRC: 'Not received',
    InboxStateOND: 'On Delivery',
    InboxStateOTH: 'Others',
    InboxStateOUT: 'Out of Scope',
    InboxStatePRE: 'Preadmission',
    InboxStatePRI: 'Printed',
    InboxStateRET: 'Returned',
    InboxStateRJT: 'Rejected',
    InboxStateREJ: 'Rejected by the postal operator',
    InboxStateRPO: 'Received at Postal Office',
    InboxStateSH: 'Sent to postal operator',
    InboxStateSPR: 'Sent for preadmission',
    InboxStateSTL: 'Stolen',
    InboxStateSOB: 'Surplus',
    InboxStateUNK: 'Unknown',
    InboxStateUP: 'Uploaded',
    InboxStateWAD: 'Wrong Address',
    InboxStateWAY: 'On the way',
    InboxStateINP: "In progress",
    InboxDateProgrammed: "Scheduled shipment",
    InboxDateEmission: "Issued",


    //
    // Invitations:
    //
    Invite: "Invite",
    InviteFail: "FAIL",
    InviteDone: "DONE",
    InviteTypeEmails: "Type e-mail addresses to invite",
    InviteTypeEmailsPlaceholder: "Type here e-mails to receive an invitation",
    InviteSelectGroup: "Select role",
    InviteSelectRealm: "Select realm the user will be allowed to work in",
    InviteSelectLanguage: "Select preferred language",
    InviteSelectMfa: "Select whether the user requires two-factor authentication",
    InviteRoleDescriptionUser: "User for sending shipments and receive returns",
    InviteRoleDescriptionAdmin: "User in charge of the management of a working group",
    InviteRoleDescriptionSupervisor: "External user will be access to all the shipments from its work group",
    InviteRoleDescriptionFactoryOper: "Access to daily tools within a printing factory",
    InviteRoleDescriptionFactoryAdmin: "Access to all features within a printing factory",
    InviteRoleDescriptionSysAdmin: "Overall accesss to information about all working groups and factories",
    InviteSendInvitations: "SEND INVITATIONS",
    InviteConfirmSend: "Confirm to send invitations",
    InviteAboutToSend: "You are about to send {0} invitations through e-mail.",
    InviteCancel: "Cancel",
    InviteProceed: "PROCEED",
    InviteRequestResults: "Invitation request results",
    InviteDialogClose: "Close",

    ///
    /// Invitation - Screen
    Invitations: "Invitations",
    InviteNewUsers: "Create new invites",
    InvitedEmail: "Invited email",
    InvitedWorkingGroup: "Working group",
    InvitedRole: "Role",
    InvitedDate: "Invited on the day",
    InvitedExpiritation: "Expiritation date",
    InvitationsTableRowsPerPage: "Rows per page",
    InvitationsTableDisplayedRows: "From {0} to {1} of {2}",
    InvitationsDescription: "In this section you can invite new users by entering their email accounts and assigning the desired work group and role. These accounts will receive an email to accept said invitation.",
    DeleteInvitation: "Delete invitation",
    InvitationsRevoke: "Are you sure you want to delete the invitation for {0}?",


    ///
    /// Front Office - Users management:
    ///
    UsersHeaderTitle: "Users",
    UsersHeaderButton: "Invite new user",
    UsersTableHeaderColumnName: "Name",
    UsersTableHeaderColumnEmail: "E-mail",
    UsersTableHeaderColumnPwdExpiration: "Password expiration",    
    UsersTableHeaderColumnStatus: "Status",
    UsersTableHeaderColumnLoginAttempts: "Login attempts",
    UsersTableHeaderColumnLockout: "Security lock",
    UsersTableHeaderColumnLockoutEnd: "Lockout end",
    UsersTableHeaderColumnlockedOutPermanent: "Lockout permanent",
    UserLockModalTitle: "Lock user",
    UserUnlockModalTitle: "Unlock user",
    UserLockModalText: "Do you really want to lock the user?",
    UserUnlockModalText: "Do you really want to unlock the user?",
    UserlockResultText: "The user {0} was successfully {1}",
    UserLocked:"locked",
    UserUnLocked: "unlocked",
    AuthenticationFactor: "Multi-factor authentication",
    UserMfaChange: "The user {0} has changed their access policy using two-factor authentication",

    ///
    /// Postal Address
    ///
    PostalAddress: "Postal Addresses",
    PostalAddressTitle: "Sender - Postal Addresses",
    PostalAddressDescription: "In this section you can edit and create the postal addresses from which you want to make your shipments. The first is the address that is used by default. It cannot be deleted, to replace it with another, click the Favorite button of the one you want to start using.",
    PostalAddressAdd: "Add postal address",
    PostalAddressEdit: "Edit",
    PostalAddressDelete: "Delete",
    PostalAddressSetAsDefault: "Set as default",
    PostalAddressDefault: "Default",
    PostalAddressSave: "Save",
    PostalAddressWho: "Sender name",
    PostalAddressIdentityCard: "Identification Document",
    PostalAddressPhone: "Phone number",
    PostalAddressStreetType: "Street type",
    PostalAddressStreetName: "Street name",
    PostalAddressStreetNumber: "Street number",
    PostalAddressStreetComplements: "Street complements",
    PostalAddressPostalCode: "Postal code",
    PostalAddressLocality: "Locality",
    PostalAddressCountryIso: "Country",
    PostalAddressConfirm: "Confirm main postal address",
    PostalAddressConfirmText: "Do you want to set this postal address as default?",
    PostalAddressConfirmRemoval: "Are you sure you want to delete the postal address?",
    PostalAddressUploadLogo: "Upload image",
    PostalAddressLogoPreview: "Preview",

    ///
    /// Email Address
    ///
    EmailAddress: "Email Addresses",
    EmailAddressTitle: "Email Addresses",
    EmailAddressDescription: "In this section you can edit and create the emails to which you want us to send notifications regarding your shipments. You can choose to receive all notifications in your user email, as well as not receive them.",
    EmailAddressAddEmail: "Add Email",
    EmailAddressEmail: "Email",
    EmailAddressValidateEmail: "Validated",
    EmailAddressCertificateEmail: "Receiver PEE & certificates",
    EmailAddressEmissionEmail: "Receiver emission confirmations",
    EmailAddressPendingValidation: "Pending validation",
    EmailAddressSave: "Save",
    EmailAddressSetAsCertificateReceiver: "Set as PEE & Certificates receiver",
    EmailAddressSetAsEmissionReceiver: "Set as emission confirmations receiver",
    EmailAddressNotifications: "Notificaciones",
    EmailAddressValidated: "Email validated",
    EmailAddressRemove: "Remove",
    EmailAddressValidationEmailMessage: " was validated successfully. By clicking the button below you will be redirected to email address management page.",
    EmailAddressRedirectTo: "Go to email address management",
    EmailAddressValidatingEmail: "Validating email ...",
    EmailAddressConfirmDeleteMessage: "Are you sure you want to delete this email?",
    EmailAddressNotConfirmDeleteMessage: "This email can not be deleted due to it is set as certificate or emission receiver.",
    EmailAddressDeleteEmail: "Delete email",
    EmailAddressDelete: "Delete",
    EmailAddressInvalidEmail: "Email introduced is invalid.",

    ///
    /// Box Selector
    ///
    BoxSelectorNoDocument: "Does not have any documents",   
    BoxSelectorSteps: "Instructions for detecting a shipping address",    
    BoxSelectorStepOneIndividual: "The system performs a search for an address on the first page of the document and displays a box with the default area where the address is located.",    
    BoxSelectorStepTwo: "If we want to select a different address location, it is enough to select a new one by clicking with the mouse in one corner of the place where it is located and, without releasing the mouse button, make a rectangle to the opposite corner.",
    BoxSelectorStepThreeIndividual: "To finish, we click on the Accept button.",    
    BoxSelectorStepOneMulti: "The system selects, by default, an address on the first page of the document on individual shipments. If it is multi-send, it performs a search in the selected zone, in all the pages.",
    BoxSelectorStepTwoNoteMulti: "You can also edit the address manually in the corresponding fields.",
    BoxSelectorStepTwoNoteTwoMulti: "If you want to save changes to a shipping address, click the Apply button.",    
    BoxSelectorStepTwoNoteThreeMulti: "If you want to delete the set values, press the Without direction button",
    BoxSelectorStepThreeMulti:"You can also, with the options buttons:",
    BoxSelectorStepThreeOneMulti: "Choose another page as the initial page to divide a shipment into several.",
    BoxSelectorStepThreeTwoMulti: "Remove a page as the initial one so that this shipment is merged with the previous one",
    BoxSelectorStepThreeThreeMulti: "Delete pages from the document that will not be included in the shipment. If a initial page is deleted, it will be merged with the previous submission and the next page will then be the initial page for that submission.",
    BoxSelectorStepThreeFourMulti: "These actions can be undone by clicking on the same options buttons",
    BoxSelectorStepFourMulti: "To finish, we click on the 'Next Continue with this division' button.",
    BoxSelectorRerence: "Instructions for detecting a shipping reference",
    BoxSelectorRerenceStepOne: "The system displays a box with the default area where the reference to be taken is located.",
    BoxSelectorRerenceStepTwo: "If we want to select a different reference, it is enough to select a new one by clicking with the mouse in one corner of the place where it is located and, without releasing the mouse button, make a rectangle to the opposite corner.",
    BoxSelectorReferenceStepThree: "To finish, we click on the Accept button.",
    

    ///
    /// Multi-shipment
    ///
    MultiShipmentTitleActions: "You can manually enter the destination address or select the area where you are located to automatically detect the address. If you want to know more about the allowed format for using automatic address detection ",
    MultishipmentAddressNotFound: "Some of your shipments do not have an address or its incorrect. Please review the front pages of each of your shipments.",
    Options: "Options",
    MultishipmentApply: "Apply",
    MultishipmentDiscard: "Without address",
    MultiShipmentRecalculate: "Recalculate proposals",
    MultiShipmentEditCurrentPage: "Edit postal address",
    MultiShipmentMarkAsInitialPage: "Mark as initial page",    
    MultiShipmentUnmarkAsInitialPage: "Unmark as initial page",
    MultishipmentEditingAddressFor: "Editing postal address for page",
    MultishipmentSuccessApplyMessage: "The changes were applied",    
    MultishipmentEnd: "Continue with this division",
    MultiShipmentWarning: "The automatic detection tool is designed to help you, but remember to review the results to make sure everything is correct and make necessary modifications if necessary.",
    MultiDetectAddress: "Detect address",
    MultiDetectAddressInfo: "(With default coordinates)",
    //
    // Report Billing
    //
    ReportBilling: "Billing",
    ReportBillingDownload: "Download report billing",
    ReportBillingDescription: "Data report will be downloaded for year and month selected",
    TotalBillingShipments: "Total shipments: ",
    NotFoundBillingData: "No data found for the selected month and year",
    ReportBillingViewList: "View List",
    ReportBillingGenerateXLS: "Generate Excel",
    ReportBillingFilter: "Select date range and clients",
    ReportBillingShowList: "Press the list button to see the results",
  }
});

/**
 * Establishes a new culture language in the aplication by loading
 * from the server the literal for the specified language.
 * @param {string} language The culture identifier, e.g. "es", "en"
 */
export let changeLanguage = async (language) => {

  if (language === 'en')
  {
    localizer.setLanguage(language)
    window.localStorage.setItem("culture", language)
    console.log("Language is now", localizer.getLanguage())
    return localizer.getLanguage()
  }

  // Replace desired language by loading literals from the server.
  await fetch('/translations/' + language + '.json')
    .then(response => response.json())
    .then(data => {
      if (data === null) {
        console.log("Language not available:", language)
        return localizer.getLanguage()
      }
      console.log("Applying language", language)
      localizer.setContent({
        [language]: data
      })
      window.localStorage.setItem("culture", language)
      console.log("Language is now", localizer.getLanguage())
      return localizer.getLanguage()
    })
    .catch(error => console.log("Language not available: ", language))
}


// WEBPACK FOOTER //
// ./src/Translator.js